import { render } from "./MatrixRequestDetail.vue?vue&type=template&id=6eb4026e&scoped=true"
import script from "./MatrixRequestDetail.vue?vue&type=script&lang=js"
export * from "./MatrixRequestDetail.vue?vue&type=script&lang=js"

import "./MatrixRequestDetail.vue?vue&type=style&index=0&id=6eb4026e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb4026e"]])

export default __exports__